module.exports = __webpack_public_path__ + "static/media/logo-aster-seguranca.60727e88.png";